// The http helpers reject with the axios `response` object, so the error body
// (containing `code`) lives at `error.data`.
export const getRsvpErrorCode = (error: unknown): string | undefined => {
  return (error as any)?.data?.code;
};
